<template>
  <div class="landingContentDiv">
    <main class="h-100 w-100">
      <landing-nav-bar/>
      <div class="flex flex-column items-center padreOyendo">
        <div id="Oyendo" class="Oyendo flex flex-column items-center w-100">
          <div class="flex flex-column items-center justify-center mainContent">
            <div class="flex flex-column">
              <h3 class="OyendoTitle">{{ $t("landing.oyendo.title") }}</h3>
            </div>
            <div class="flex flex-column">
              <carousel class="Carousel2" :per-page="1" :navigationEnabled="false" :paginationEnabled="false" paginationActiveColor="#FF0085" paginationColor="#fff"
                :loop="true" :autoplay="true" :autoplayTimeout="5000" :hover-cancel-play="false">
                <slide>
                  <div class="flex flex-column justify-center">
                    <div class="flex justify-center flex-wrap items-center">
                      <div class="OyendoText">
                        <span class="OyendoText">{{ $t("landing.oyendo.carousel.text1") }} </span>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="flex flex-column justify-center">
                    <div class="flex justify-center flex-wrap items-center">
                      <div class="OyendoText">
                        <span class="OyendoText">{{ $t("landing.oyendo.carousel.text2") }} </span>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="flex flex-column justify-center">
                    <div class="flex justify-center flex-wrap items-center">
                      <div class="OyendoText">
                        <span class="OyendoText">{{ $t("landing.oyendo.carousel.text3") }}</span>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div> 
            <div class="flex flex-column items-center ffblack sumate">
              <h1 class="m-0">{{ $t("landing.join") }}</h1>
              <h2 class="m-0">{{ $t("landing.joinText") }}</h2>
              <router-link class="btnPildoraPlanesO ffbold" :to="{name: 'planes'}" title="Planes">{{ $t("landing.oyendo.button") }}</router-link>
            </div>           
          </div>
        </div>
      </div>
      <home-footer/>
    </main>
  </div>
</template>

<script>
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeFooter from '@/components/home/HomeFooter.vue'
  import LandingNavBar from './LandingNavBar.vue'
  import {Carousel, Slide} from 'vue-carousel'
  import { mapGetters } from 'vuex'

  export default {
    name: 'oyendo',
    components: {
      ProviderLink,
      DirectLinkModal,
      FontAwesomeIcon,
      HomeFooter,
      LandingNavBar,
      Carousel,
      Slide
    },
    mounted () {
      this.scrollToTop()
    },
    methods: {
      scrollToTop () {
        window.scrollTo(0, 0)
      }
    },
    computed: {
      ...mapGetters('translator', [
        'joinImage'
      ])
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Montserrat Black';
    src: url('~@/assets/fonts/new_landing/Montserrat-Black.otf');
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat Bold';
    src: url('~@/assets/fonts/new_landing/Montserrat-Bold.otf');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  .m-0 {
    margin: 0;
  }

  .ffblack {
    font-family: 'Montserrat Black';
  }

  .ffbold {
    font-family: 'Montserrat Bold';
  }

  .sumate{
    font-size: 20px;
  }

  .mainContent {
    position: relative;
    width: 38vw;
    left: 340px;
  }

  .padreOyendo{
    width: 100%;
    height: 100vh;
  }

  .landingContentDiv{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
    background-color: #393839;
    height: calc(100vh - 3em - 58px);
  }

  .sumateDiv{
    margin-bottom: 45px;
  }

  .Oyendo{
    background-image: url('~@/assets/Landing/nueva_landing/music_lovers.jpg');
    margin: 48px 0px 0px 0px;
    background-size: cover;
    background-position: center;
    line-height: initial;
    height: 100vh;
  }

  .OyendoTitle{
    font-size: 75px;
    font-family: 'Montserrat Black';
    text-align: center;
  }

  .OyendoText {
    font-size: 30px;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    display: block;
    -webkit-margin-before: .67em;
    margin-block-start: .67em;
    -webkit-margin-after: .67em;
    margin-block-end: .67em;
    -webkit-margin-start: 0;
    margin-inline-start: 0;
    -webkit-margin-end: 0;
    margin-inline-end: 0;
    font-family: 'Montserrat Bold';
  }

  .btnPildoraPlanesO{
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 25px;
      width: 200px;
      border-radius: 35px 35px 35px 35px;
      margin-right: -3px;
      outline: 0;
      border-width: 1px;
      border-color: #FF0085;
      background-color: #FF0085;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;
  }
  .btnPildoraPlanesO:hover{
    background-color: #fff !important;
    color: #FF0085 !important;
  }

  @media screen and (max-width:1500px) {

    .Oyendo{
      // background-image: url('~@/assets/Landing/nueva_landing/music_lovers.jpg');
      background-size: cover;
      background-position: center;
      margin-top: 48px;
      height: 100%;
      width: 100%;
    }

    .OyendoTitle{
      font-size: 50px;
    }

    .OyendoText {
      font-size: 25px;
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      display: block;
      -webkit-margin-before: .67em;
      margin-block-start: .67em;
      -webkit-margin-after: .67em;
      margin-block-end: .67em;
      -webkit-margin-start: 0;
      margin-inline-start: 0;
      -webkit-margin-end: 0;
      margin-inline-end: 0;
      font-family: 'Montserrat Bold';
    }

    .btnPildoraPlanesO{
      padding-bottom: 10px;
      padding-top: 10px;
      font-size: 25px;
        width: 200px;
        border-radius: 35px 35px 35px 35px;
        margin-right: -3px;
        outline: 0;
        border-width: 1px;
        border-color: #FF0085;
        background-color: #FF0085;
        color: #fff;
        outline-offset: 1px;
        text-decoration: none;
        overflow: hidden;
        text-align: center;
    }
    .btnPildoraPlanesO:hover{
      background-color: #fff !important;
      color: #FF0085 !important;
    }
  }

  @media screen and (max-width:800px) {
    .mainContent {
      position: unset;
      width: 100%;
    }
    .Selecciona{
      margin-top: 75px;
      flex-wrap: wrap;  
    }

    .btnPildoraPlanesO{
      padding-bottom: 10px;
      padding-top: 10px;
      font-size: 25px;
        width: 200px;
        border-radius: 35px 35px 35px 35px;
        margin-right: -3px;
        outline: 0;
        border-width: 1px;
        border-color: #FF0085;
        background-color: #FF0085;
        color: #fff;
        outline-offset: 1px;
        text-decoration: none;
        overflow: hidden;
        text-align: center;
    }
    .btnPildoraPlanesO:hover{
      background-color: #fff !important;
      color: #FF0085 !important;
    }
  }

  @media screen and (max-width:700px) {
    .mainContent {
      position: unset;
      width: 100%;
    }
    
    .OyendoTitle{
      font-size: 50px;
      margin: 25px 0px 25px 0px;
    }
    
    .OyendoText {
      font-size: 25px;
      text-align: center;
      display: block;
      -webkit-margin-before: .67em;
      margin-block-start: .67em;
      -webkit-margin-after: .67em;
      margin-block-end: .67em;
      -webkit-margin-start: 0;
      margin-inline-start: 0;
      -webkit-margin-end: 0;
      margin-inline-end: 0;
      font-family: 'Montserrat Bold';
    }

    .Carousel2{
      width: 85vw;
    }

    .btnPildoraPlanesO{
      padding-bottom: 10px;
      padding-top: 10px;
      font-size: 25px;
        width: 200px;
        border-radius: 35px 35px 35px 35px;
        margin-right: -3px;
        outline: 0;
        border-width: 1px;
        border-color: #FF0085;
        background-color: #FF0085;
        color: #fff;
        outline-offset: 1px;
        text-decoration: none;
        overflow: hidden;
        text-align: center;
    }
    .btnPildoraPlanesO:hover{
      background-color: #fff !important;
      color: #FF0085 !important;
    }

    .Selecciona{
      height: 50%;
      width: 50%;
    }
  }


    html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: $background-color;
    height: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
    background-color: $background-color;
    height: $main-height;
    width: 100vw;
  }

  .main {
    height: $main-height;
    width: 100vw;
  }

  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .textColor {
    color: $text-color;
  }

  .iconColor {
    color: $icon-color;
  }

  .accent {
    color: $accent-color;
  }
  
  .errorText { 
    color: $error-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #fff;
    background-color: $background-color;
    color: $text-color !important;
  }

  .error {
    border-bottom: 1px solid $error-color;
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  ::placeholder {
    color: $text-color !important;
  }

  .v--modal {
    background-color: $background-color !important;
    color: #aaa !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Landing/Oyendo.vue